/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const TokenResponseR = t.interface({});

// optional attributes
const TokenResponseO = t.partial({
  sessionToken: t.string
});

export const TokenResponse = t.intersection(
  [TokenResponseR, TokenResponseO],
  "TokenResponse"
);

export type TokenResponse = t.TypeOf<typeof TokenResponse>;
